//
//
//

import { Toast } from "vant"
export default {
  name: "logout",
  methods: {
    logout() {
        var thiss = this
        var user = this.$store.getters.getUserInfo
        // alert('啥'+JSON.stringify(user))
        if (user != null && user.id != null) {
          this.$store.dispatch('user/fnLoginDoLogout',JSON.stringify(user)).then(res=>{
            // alert('res'+JSON.stringify(res))
            // if(res.data.retCode == 1){
              // 重新获取token信息
              // const token = thiss.$store.getters['user/getToken']
              // thiss.$store.commit('setToken',token)
              thiss.$store.commit('setUserInfo', {})
              thiss.$store.commit('setToken', '')
              thiss.$router.push('/index')
              thiss.$nextTick(()=>{
                localStorage.setItem('alreadyLogin', 'alreadyLogin' + new Date().getTime() + '')
              })
            // }else{
            //   Toast(res.data.retMsg)
            //   thiss.$router.push('/index')
            // }
          })
       } else {
          // 重新获取token信息
          // const token = thiss.$store.getters['user/getToken']
          // thiss.$store.commit('setToken',token)
          thiss.$store.commit('setUserInfo', {})
          thiss.$store.commit('setToken', '')
          thiss.$router.push('/index')
          thiss.$nextTick(()=>{
            localStorage.setItem('alreadyLogin', 'alreadyLogin' + new Date().getTime() + '')
          })
       }
    }
  },
  created(){
    this.logout()
  }
};



// WEBPACK FOOTER //
// ./src/pages/login/logout.vue